import { getStoreAccessors } from '../vuex-typescript'
import RootState from '../state'
import ComponentState from './state'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'

const { read, commit, dispatch } = getStoreAccessors<ComponentState, RootState>('common')

export namespace Mutations {
  export const addNotification = commit(mutations.addNotification, 'addNotification')
  export const clearNotifications = commit(mutations.clearNotifications, 'clearNotifications')
  export const removeNotification = commit(mutations.removeNotification, 'removeNotification')
  export const removeNotificationByType = commit(mutations.removeNotificationByType, 'removeNotificationByType')
  export const setErrorStatus = commit(mutations.setErrorStatus, 'setErrorStatus')
}

export namespace Actions {
  export const addNotification = dispatch(actions.addNotification, 'addNotification')
  export const clearNotifications = dispatch(actions.clearNotifications, 'clearNotifications')
  export const removeNotification = dispatch(actions.removeNotification, 'removeNotification')
  export const removeNotificationByType = commit(mutations.removeNotificationByType, 'removeNotificationByType')
}

export namespace Getters {
  export const notifications = read(getters.notifications, 'notifications')
  export const errorStatus = read(getters.errorStatus, 'errorStatus')
}
